import type { PendingSurveyVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const studentRetrievePendingSurveys = createApiThunk<PendingSurveyVM[], void>(
  "student/studentRetrievePendingSurveys",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getPendingSurveys();
  },
);
